module.exports = __webpack_public_path__ + "static/img/role.df25220.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/kc/role.png
// module id = 8aPc
// module chunks = 7